<template>
  <div
    id="sticky-button"
    :class="[
      `w-full fixed left-0 p-16 border-t-1 border-solid border-grey-divider-subdued bg-foreground`,
      variantStyles,
      pageHasBottomNav ? 'bottom-80' : 'bottom-0',
    ]"
  >
    <Button
      :value="value"
      size="medium"
      class="w-full"
      :variant="btnVariant"
      :href="href || undefined"
      :to="to || undefined"
      :loading="loading"
      :type="type"
      @click="clickHandler"
    />
  </div>
</template>

<script lang="ts">
import Button from '../button/Button.vue';

export default {
  name: 'StickyButton',
  components: { Button },
  props: {
    value: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: undefined,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'mobile',
      validator(value) {
        // The value must be one of these strings
        return ['mobile', 'alwaysSticky'].includes(value);
      },
    },
    btnVariant: {
      type: String,
      default: 'primary',
    },
    href: {
      type: String,
      default: undefined,
    },
    pageHasBottomNav: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
      validator(value: string) {
        return ['button', 'submit', 'reset'].includes(value);
      },
    },
  },
  emits: ['click'],
  computed: {
    variantStyles() {
      if (this.variant === 'alwaysSticky') {
        return 'z-10 sm:sticky sm:box-shadow-sm sm:rounded-b-lg';
      }
      return 'sm:static sm:border-0 sm:p-0';
    },
  },
  methods: {
    clickHandler(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style>
/* fix for cookie banner + support button overlap with sticky button */
@media only screen and (max-width: 480px) {
  main:has(#sticky-button) ~ #onetrust-consent-sdk #ot-sdk-btn-floating,
  main:has(#sticky-button) ~ div:has(iframe#launcher) iframe#launcher {
    bottom: 80px !important;
  }
}
</style>
